import { DragOverlay } from "@dnd-kit/core";
import type React from "react";
import { useId } from "react";

import { SurveyRespondQuestionCardDynamicRepeaterItem } from "./SurveyRespondQuestionCardDynamicRepeaterItem";

interface SurveyRespondQuestionCardDynamicRepeaterItemOverlayProps {
  title: string;
  description?: string;
}

export function SurveyRespondQuestionCardDynamicRepeaterItemOverlay({
  title,
  description,
}: SurveyRespondQuestionCardDynamicRepeaterItemOverlayProps): React.ReactNode {
  const id = useId();

  return (
    <DragOverlay>
      {/* A non-draggable UI to mock the dragging element */}
      <SurveyRespondQuestionCardDynamicRepeaterItem
        title={title}
        description={description}
        id={id}
        canMoveDown={false}
        canMoveUp={false}
        onMove={() => {}}
        disabled
      />
    </DragOverlay>
  );
}
